import { useTranslation } from 'react-i18next';
import { DealerReviewSummary } from 'types/Apis/SearchURL';

import BaseAggregateCard from '../Reviews/AggregateCard';

interface AggregateCardProps {
  reviewSummary: DealerReviewSummary;
}

export default function AggregateCard({ reviewSummary }: AggregateCardProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <BaseAggregateCard
      breakdownByRatingPercentages={{
        fiveStar: reviewSummary.countsByRating.fiveStar,
        fourStar: reviewSummary.countsByRating.fourStar,
        threeStar: reviewSummary.countsByRating.threeStar,
        twoStar: reviewSummary.countsByRating.twoStar,
        oneStar: reviewSummary.countsByRating.oneStar,
      }}
      title={t('seoSrp.dealerReviews.aggregateCard.header')}
      color="gold"
      writeReviewHref="https://docs.google.com/forms/d/e/1FAIpQLSe-OmCY-WFRnwRt8YsbSzSob1IOmnwCU9TlhxAm4Vdx9O8e1g/viewform"
      {...reviewSummary}
      categoryAverages={{
        [t('seoSrp.dealerReviews.pricing')]: reviewSummary.averagesByCategory.pricingRating,
        [t('seoSrp.dealerReviews.service')]: reviewSummary.averagesByCategory.serviceRating,
        [t('seoSrp.dealerReviews.helpfulness')]: reviewSummary.averagesByCategory.helpfulnessRating,
        [t('seoSrp.dealerReviews.responsiveness')]:
          reviewSummary.averagesByCategory.responsivenessRating,
      }}
    />
  );
}
